/**
 * Created by andrey on 20.02.18.
 */

const Booster = function (id) {
    BaseBooster.call(this, id);

    this.onToggleArrowListener = function () {};
    this.onToggleTintListener = function () {};
    this.onExecuteListener = function () {};
    this.onDisableListener = function () {};
    this.onEnableListener = function () {};

    this.alarm = new Alarm();
    this.alarm.onChangeListeners.tint = this.toggleTint.bind(this);
    this.alarm.onChangeListeners.arrow = this.toggleArrow.bind(this);

    cleverapps.focusManager.on("changeFocus", () => {
        if (this.alarm.isOn()) {
            this.stopHint();
        }
    });
};

Booster.prototype = Object.create(BaseBooster.prototype);
Booster.prototype.constructor = Booster;

Booster.prototype.clear = function () {
    this.alarm.clear();
};

Booster.prototype.onUserActive = function () {
    this.stopHint();
};

Booster.prototype.clearAlarmTimeout = function () {
    if (this.alarmTimeout) {
        clearTimeout(this.alarmTimeout);
        this.alarmTimeout = undefined;
    }
};

Booster.prototype.startHint = function (manual) {
    if (manual) {
        this.manualAlarm = true;
    }
    this.alarm.start("hint", 1);
    this.clearAlarmTimeout();
};

Booster.prototype.stopHint = function () {
    this.manualAlarm = false;
    this.alarm.stop("hint");
    this.clearAlarmTimeout();
};

Booster.prototype.onUserInactive = function () {
    if (this.manualAlarm || cleverapps.focusManager.isFocused()) {
        return;
    }
    this.startHint();
    this.alarmTimeout = setTimeout(this.stopHint.bind(this), cleverapps.parseInterval(Booster.StopAlarmTimeout));
};

Booster.prototype.toggleTint = function () {
    this.onToggleTintListener(this.alarm.isOn());
};

Booster.prototype.toggleArrow = function () {
    this.onToggleArrowListener(this.alarm.isOn());
};

Booster.prototype.getControls = function () {
    return [];
};

Booster.prototype.onPressed = function (f) {
    if (Game.currentGame.outcome !== GameBase.OUTCOME_UNKNOWN) {
        f();
        return;
    }

    if (Game.currentGame.counter.isActive()) {
        f();
        return;
    }

    if (Game.currentGame.open && Game.currentGame.open.counter.isActive()) {
        f();
        return;
    }

    if (this.canExecute()) {
        this.execute(cleverapps.EVENTS.BOOSTERS_USE_TYPE.USER);
        f();
    } else if (this.isAdsAvailable()) {
        cleverapps.rewardedAdsManager.playRewarded(this.limit, () => {
            cleverapps.focusManager.showControlsWhileFocused(this.getControls());
            Game.currentGame.counter.setTimeout(() => {
                cleverapps.boosters.add(this.id);
                this.execute(cleverapps.EVENTS.BOOSTERS_USE_TYPE.ADS);
                f();
            }, 400);
        }, () => {
            f();
        });
    } else if (this.buy()) {
        this.execute(cleverapps.EVENTS.BOOSTERS_USE_TYPE.HARD);
        f();
    } else {
        f();
    }
};

Booster.prototype.execute = function (useType) {
    cleverapps.tutorial.trigger("executeBooster");

    this.onExecute();

    this.use(useType);

    this.onExecuteListener();
};

Booster.StopAlarmTimeout = "5 seconds";
